import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap } from '../../components';
import LibraryForm from './LibraryForm';

export default function NewLibraryScreen() {
  return (
    <ScreenWrap>
      <Stack gap={3}>
        <Stack gap={1}>
          <HeaderBreadcrumbs
            title="Create New Library Content"
            items={[{ name: 'Library Content', url: '/library' }]}
          />
        </Stack>

        <LibraryForm existing={null} />
      </Stack>
    </ScreenWrap>
  );
}
